import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { submitCart } from '@services/shoppingCartService';
import { cartQueryKey } from '@hooks/useCart/useCart';
import type { ShoppingCartDTO } from '@t/api.types';

interface UseSubmitCartOptions {
  onError?: (error: Error) => void;
}

export const useSubmitCart = (
  sessionId: string,
  { onError }: UseSubmitCartOptions = {}
): UseMutationResult<ShoppingCartDTO, Error, void> => {
  const queryClient = useQueryClient();
  return useMutation<ShoppingCartDTO, Error, void>({
    mutationFn: () => submitCart(sessionId),
    onSuccess: (cart) => queryClient.setQueryData<ShoppingCartDTO>(cartQueryKey(sessionId), cart),
    onError,
  });
};
